<div class="d-flex align-items-center volume-slider">
	<div>
		<i aria-hidden="true" class="fas fa-fw" [ngClass]="getVolumeIcon()"></i>
	</div>
	<input
		class="volume-slider-control"
		id="{{ id }}"
		max="100"
		min="0"
		type="range"
		[formControl]="form.controls.volume"
		[step]="step"
		(click)="$event.stopPropagation()"
	/>
	@if (showValue) {
		<div class="volume-slider-value">
			{{ form.controls.volume.value }}
		</div>
	}
</div>
